import React from 'react';
import { Player, WinResult } from '../core/types';
import CardComponent from './CardComponent';
import MeldDisplay from './MeldDisplay';
import '../styles/Modals.css';

interface SettlementModalProps {
  winResult: WinResult | null;
  players: Player[];
  currentRound: number;
  totalRounds: number;
  onNextRound: () => void;
  onRestartMatch: () => void;
}

const SettlementModal: React.FC<SettlementModalProps> = ({
  winResult,
  players,
  currentRound,
  totalRounds,
  onNextRound,
  onRestartMatch
}) => {
  if (!winResult) return null;

  const winner = players.find(p => p.id === winResult.winnerId);
  const isMatchOver = currentRound >= totalRounds;

  return (
    <div className="modal-overlay settlement-overlay">
      <div className="settlement-certificate">
        <div className="cert-border-corner top-left"></div>
        <div className="cert-border-corner top-right"></div>
        <div className="cert-border-corner bottom-left"></div>
        <div className="cert-border-corner bottom-right"></div>

        <div className="cert-header">
          <div className="cert-seal">🀄</div>
          <h2 className="cert-title">
            {winResult.isWin ? (
              <span>
                🎉 {winner?.name} <span className="gold-text">胡牌大捷！</span>
              </span>
            ) : (
              <span className="draw-title">🍂 荒庄 (本局平局流局)</span>
            )}
          </h2>
          <div className="cert-subtitle">
            第 {currentRound} / {totalRounds} 局 战绩结算榜
          </div>
        </div>

        <div className="cert-details">
          {winResult.isWin && (
            <div className="cert-body">
            {/* 胡息与名堂 */}
            <div className="cert-score-banner">
              <div className="banner-huxi">
                <span className="huxi-num">{winResult.totalHuxi}</span>
                <span className="huxi-label">胡息</span>
              </div>
              <div className="banner-patterns">
                {winResult.specialPatterns.map((pat, idx) => (
                  <span key={idx} className="pattern-pill">
                    ⭐ {pat}
                  </span>
                ))}
              </div>
            </div>

            {/* 所有成牌组合 */}
            <div className="cert-melds-section">
              <div className="section-label">成牌明细与将牌：</div>
              <div className="settlement-melds-grid">
                <MeldDisplay melds={winResult.melds} />
                {winResult.eyes.length > 0 && (
                  <div className="settlement-eyes-group">
                    <div className="eyes-tag">将牌 (对子)</div>
                    <div className="eyes-cards">
                      {winResult.eyes.map((c, i) => (
                        <CardComponent key={c.id || i} card={c} isSmall={true} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            </div>
          )}

          {/* 各玩家得分变动与总分 */}
          <div className="cert-players-table">
            <div className="table-header">
              <span>玩家</span>
              <span>本局得失</span>
              <span>总积分</span>
            </div>
            {players.map(player => {
              const delta = winResult.scoreDelta[player.id] || 0;
              return (
                <div
                  key={player.id}
                  className={`table-row ${player.id === winResult.winnerId ? 'winner-row' : ''}`}
                >
                  <div className="player-col">
                    <span className="p-avatar">{player.avatar}</span>
                    <span className="p-name">{player.name}</span>
                  </div>
                  <div className={`delta-col ${delta > 0 ? 'plus' : delta < 0 ? 'minus' : ''}`}>
                    {delta > 0 ? `+${delta}` : delta}
                  </div>
                  <div className="total-col">{player.score}</div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="cert-footer">
          {isMatchOver ? (
            <button className="btn-cert-primary" onClick={onRestartMatch}>
              🏆 比赛结束，再来一场！
            </button>
          ) : (
            <button className="btn-cert-primary" onClick={onNextRound}>
              ⏩ 进入第 {currentRound + 1} 局
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettlementModal;